<template>
  <div class="program-pages">
    <link itemprop="url" rel="stylesheet" href="css/programs.css"/>
    <section>
      <HeaderOfPage
      :bgSrc          = "'banner-22.jpg'"
      :titleOfPage    = "'البرامج'"
      :theDiscription = "'موقع أجـــازة بــوك هو بوابتك المميزة للسفر في أي مكان داخل أو خارج جمهورية مصر العربية لو حابب تسافر وتتعرف علي كل أماكن العالم السياحية ، وتستمتع بكل شبر داخل وخارج مصر وتعيش المغامرة مع اصحابك وتتفسح مع عيلتك، تقدر تتصفح أجـــازة بــوك وتختار عايز تسافر فين'"
      />
    </section>
    <section class="pages-container">
      <ProgramsContent/>
    </section>
  </div>
</template>
<script type="text/javascript">
import HeaderOfPage    from '../global/HeaderOfPage'
import ProgramsContent from './ProgramsContent'
  export default {
    name:'Programs',
    components: {
      HeaderOfPage,
      ProgramsContent
    }
  }
</script>
